module.exports = __webpack_public_path__ + "static/media/blueTick.b661dd9a.svg";